// Types
import { ProductProps } from 'types/Product.types';

export default function getItemQuantityById(id: string | undefined, items: ProductProps[]) {
  const item = items.find(item => item.id === id);

  return item ? item.quantity : undefined;
}
